import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "../createAppSlice";

export interface AppSliceState {
  fullName: string;
  message: string;
}

const initialState: AppSliceState = {
  fullName: "",
  message: "",
};

// If you are not using async thunks you can use the standalone `createSlice`.
export const appSlice = createAppSlice({
  name: "app",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: (create) => ({
    setFullName: create.reducer((state, action: PayloadAction<string>) => {
      state.fullName = action.payload;
    }),
    setMessage: create.reducer((state, action: PayloadAction<string>) => {
      state.message = action.payload;
    }),
    setNameAndMessage: create.reducer(
      (state, action: PayloadAction<{ name: string; message: string }>) => {
        state.fullName = action.payload.name;
        state.message = action.payload.message;
      }
    ),
  }),
  selectors: {
    selectFullName: (state) => state.fullName,
    selectMessage: (state) => state.message,
  },
});

// Action creators are generated for each case reducer function.
export const { setFullName, setMessage, setNameAndMessage } = appSlice.actions;

// Selectors returned by `slice.selectors` take the root state as their first argument.
export const { selectFullName, selectMessage } = appSlice.selectors;
